import ApiEndpoint from '../globals/api-endpoint'

class RestaurantSource {
  static async home () {
    const response = await fetch(ApiEndpoint.HOME)
    const responseJson = await response.json()
    return responseJson.restaurants
  }

  static async detailRestaurant (id) {
    const response = await fetch(ApiEndpoint.DETAIL(id))
    const responseJson = await response.json()
    return responseJson.restaurant
  }

  static async postReview (data) {
    const response = await fetch(ApiEndpoint.POST, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: data
    })
    return await response.json()
  }
}

export default RestaurantSource
